import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "@mui/material";

const CallEndModal = (props) => {
  const { showCallEndModal, closeCallEndModal, handleYes } = props;
  return (
    <>
      {showCallEndModal && (
        <Modal
          open={showCallEndModal}
        >
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="call-end-modal-wrapper">
              <div className="py-sm-5 py-lg-4 py-5 px-5 my-2">
                <div className=" text-center mt-3 ">
                  <h4 className="px-2" style={{ color: "1B2027" }}>
                    <b>Are you sure you want to end this call?</b>
                  </h4>
                  <div className=" container p-2 mb-3 text-center">
                    <div>
                      <p style={{ fontSize: "18px" }}>
                        Once ended, you cannot rejoin the call
                      </p>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="text-center">
                    <Button
                      className="btn btn-lg border-0 mb-md-2 mx-3 border rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                      onClick={handleYes}
                    >
                      Yes
                    </Button>

                    <Button
                      className="btn btn-lg border mb-md-2 mx-3 rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#fff", color: "#17BAE0" }}
                      onClick={closeCallEndModal}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default CallEndModal;
